export const GET_EVENTS_CAT_FETCH = "GET_EVENTS_CAT_FETCH";
export const GET_EVENTS_CAT_SUCCESS = "GET_EVENTS_CAT_SUCCESS";
